<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h2 class="subtitle">{{ page.subtitle }}</h2>
					<h1>{{ page.title || page.header }}</h1>

					<br />
					<client-only>
						<component
							:is="'script'"
							id="hotels-for-trees-klant"
							src="https://hotelsfortrees.com/wp-content/plugins/Hotel-for-tree/lib/hotelsForTreesCards/index.js"
							data-columns="443"
							async
						/>
						<div class="card-unset relative reset-this">
							<div class="card card-bg">
								<div class="logo-section reset-this">
									<a id="hotel-url-link" href="https://hotelsfortrees.com/en/" target="_blank"
										><img
											class="logo-card-hft reset-this"
											src="https://hotelsfortrees.com/wp-content/uploads/2022/04/logo-1.png"
									/></a>
								</div>
								<div class="divider"></div>
								<div class="right-section">
									<span class="hotel">Guests of <span id="hotel">(hotel name)</span></span>
									<p class="trees">Have so far planted <mark id="treesAmount">0</mark> trees.</p>
								</div>
							</div>
						</div>
					</client-only>
					<br />
					<br />
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
					<p v-if="bookingID">
						<book-button class="button button-cta" :roomid="page.bookingID" aria-label="Reserve now">
							<span>{{ $t('bookThisRoom') }}</span>
						</book-button>
					</p>
				</div>
			</template>
		</main-content>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:items="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

onUpdated(() => {
	reloadNuxtApp();
});
</script>
